;
define("cart_promocode_list_item.tpl", function(){});

